



















































































import {
  Prop,
  Vue,
  Component,
} from "@/shared/vuepack";

import * as _ from "lodash";
import HsabLoginWrapper from "@/shared/components/ui/HsabLoginWrapper.vue";
import { EbtoPricingOffer } from "@/employee/route-names";

@Component({
  components: {
    HsabLoginWrapper
  }
})
export default class GeneralInformation extends Vue {

  onSubmit (): void {
    this.$router.push({ name: EbtoPricingOffer });
  }
}
